import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SourcingBuyerStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
------------------------------- */
  .table-wrapper {
    margin-top: 21px;
    overflow-x: auto;

    /* width */
    /* ::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    } */

    /* Track */
    /* ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    } */

    /* Handle */
    /* ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    } */

    /* Handle on hover */
    /* ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    } */
  }

  .table.user {
    min-width: 1680px;
  }

  .table {
    .table-row {
      min-width: 1680px;

      .event-no {
        flex: 0 0 120px;
        min-width: 120px;
        max-width: 120px;
      }

      .event-name {
        flex: 0 0 200px;
        min-width: 200px;
        max-width: 200px;
      }

      .employee-type {
        flex: 0 0 120px;
        min-width: 120px;
        max-width: 120px;
        justify-content: center;
        text-align: center;
      }

      .start-date {
        flex: 0 0 180px;
        min-width: 180px;
        max-width: 180px;
        justify-content: center;
        text-align: center;
      }

      .end-date {
        flex: 0 0 180px;
        min-width: 180px;
        max-width: 180px;
        justify-content: center;
        text-align: center;
      }

      & > .active-status {
        flex: 0 0 140px;
        min-width: 140px;
        max-width: 140px;
        justify-content: center;
        text-align: center;
      }

      .seal-status {
        flex: 0 0 150px;
        min-width: 150px;
        max-width: 150px;
        justify-content: center;
        text-align: center;
      }

      .award-status {
        flex: 0 0 180px;
        min-width: 180px;
        max-width: 180px;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 180px;
        min-width: 180px;
        max-width: 180px;
        justify-content: center;
        text-align: center;
      }

      .actions {
        flex: 0 0 230px;
        min-width: 230px;
        max-width: 230px;

        & > .section {
          justify-content: flex-start;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 180px;

          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 170px;

          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 160px;
        }
      }
    } */

    /* .select-control {
      min-width: 140px;

      .select__menu {
        min-width: 160px;
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 145px;
        }
      }
    } */

    /* .select-control {
      min-width: 130px;

      .select__menu {
        min-width: 145px;
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    .table {
      .table-row {
        /* .actions {
          min-width: 130px;
        } */
      }
    }

    /* .select-control {
      min-width: 120px;

      .select__menu {
        min-width: 140px;
      }
    } */
  }
`

export const SourcingSupplierStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1350px;
  } */
  .no-result-found {
    padding-top: 30px;
  }

  .table-purchasing {
    min-width: 2000px;
  }

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .event-no {
        flex: 0 0 10%;
        min-width: 110px;
      }

      .event-name {
        flex: 0 0 15%;
        min-width: 170px;
      }

      .buyer-name {
        flex: 0 0 8%;
        min-width: 160px;
        justify-content: center;
        text-align: center;
      }

      .event-type {
        flex: 0 0 8%;
        min-width: 160px;
        justify-content: center;
        text-align: center;
      }

      .start-date {
        flex: 0 0 20%;
        min-width: 190px;
        justify-content: center;
        text-align: center;
      }

      .end-date {
        flex: 0 0 20%;
        min-width: 190px;
        justify-content: center;
        text-align: center;
      }

      .active-status {
        flex: 0 0 15%;
        min-width: 130px;
        justify-content: center;
        text-align: center;
      }

      .seal-status {
        flex: 0 0 15%;
        min-width: 130px;
        justify-content: center;
        text-align: center;
      }

      .award-status {
        flex: 0 0 12%;
        min-width: 215px;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 10%;
        min-width: 215px;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 10%;
        min-width: 150px;
        justify-content: center;
        text-align: center;
      }
    }
  }

  .user {
    min-width: 2000px;
  }
  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 2305.98px) {
    .content-body:has(#filter_search_input:focus) {
      .tbody {
        .table-column {
          div {
            color: #06304f;
          }
        }
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    /* .table {
      .table-row {
        .actions {
          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* .table {
      .table-row {
        .actions {
          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* .select-control {
      min-width: 140px;

      .select__menu {
        min-width: 160px;
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* .select-control {
      min-width: 130px;

      .select__menu {
        min-width: 145px;
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    .table {
      .table-row {
        /* .actions {
          min-width: 100px;
        } */

        .start-date {
          min-width: 170px;
        }

        .end-date {
          min-width: 170px;
        }
      }
    }

    /* .select-control {
      min-width: 120px;

      .select__menu {
        min-width: 140px;
      }
    } */
  }
`

export const SourcingProjectsStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .table-souring {
    min-width: 992px;
  }

  .date_sourcing_projects {
    margin-left: 10px;
    flex-direction: column;
    width: auto;
  }

  .table-wrapper {
    margin-top: 21px;

    /* width */
    /* ::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    } */

    /* Track */
    /* ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    } */

    /* Handle */
    /* ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    } */

    /* Handle on hover */
    /* ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    } */
  }

  .table {
    .table-row {
      .project-no {
        flex: 0 0 14%;
        min-width: 110px;
      }

      .project-name {
        flex: 1 1 auto;
        min-width: 170px;
      }

      .create-date {
        flex: 0 0 14%;
        min-width: 190px;
        justify-content: center;
        text-align: center;
      }

      .status {
        flex: 0 0 12%;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 15%;
        min-width: 150px;
        justify-content: center;
        text-align: center;
      }

      /* .actions {
        min-width: 190px;

        & > .section {
          justify-content: flex-start;
        }
      } */
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1396.98px) {
    .content-body:has(#filter_search_input:focus) {
      .tbody {
        .table-column {
          div {
            color: #06304f;
          }
        }
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 180px;

          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 170px;

          & > .section {
            justify-content: flex-start;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 160px;
        }
      }
    } */

    /* .select-control {
      min-width: 140px;

      .select__menu {
        min-width: 160px;
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 145px;
        }
      }
    } */

    /* .select-control {
      min-width: 130px;

      .select__menu {
        min-width: 145px;
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    /* .table {
      .table-row {
        .actions {
          min-width: 130px;
        }

        .start-date {
          min-width: 170px;
        }

        .end-date {
          min-width: 170px;
        }
      }
    } */

    /* .select-control {
      min-width: 120px;

      .select__menu {
        min-width: 140px;
      }
    } */
  }
`

export const SourcingProjectDetailStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  .form-group > label {
    flex: 0 0 165px;
  }

  .form-group {
    &.date-period {
      .date-picker-wrapper {
        width: 100%;
        max-width: 500px;
        min-width: 250px;
      }
    }

    &.status {
      .form-group-inner-wrapper {
        position: relative;
      }

      .status-icon-help {
        width: 18px;
        position: absolute;
        left: 125px;
        z-index: 2;
      }
    }

    .form-group-inner-wrapper {
      flex-wrap: wrap;
    }
  }

  .form-group .target-saving .input-control {
    max-width: 125px;
    min-width: 80px;
    margin-right: 10px;

    .input {
      text-align: center;
    }
  }

  .main-content .content-body .form-actions {
    margin-bottom: 50px;

    .button-group {
      &:last-child {
        justify-content: flex-end;
      }
    }

    .button {
      width: 145px;
    }
  }

  .text {
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  .user {
    min-width: 2000px;
  }

  .table {
    .table-row {
      .event-no {
        flex: 0 0 10%;
        min-width: 110px;
      }

      .event-name {
        flex: 0 0 18%;
        min-width: 170px;
      }

      .employee-type {
        flex: 0 0 8%;
        min-width: 160px;
        justify-content: center;
        text-align: center;
      }

      .start-date {
        flex: 0 0 20%;
        min-width: 190px;
        justify-content: center;
        text-align: center;
      }

      .end-date {
        flex: 0 0 20%;
        min-width: 190px;
        justify-content: center;
        text-align: center;
      }

      & > .active-status {
        flex: 0 0 10%;
        min-width: 120px;
        justify-content: center;
        text-align: center;
      }

      .seal-status {
        flex: 0 0 10%;
        min-width: 155px;
        justify-content: center;
        text-align: center;
      }

      .award-status {
        flex: 0 0 12%;
        min-width: 215px;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 10%;
        min-width: 215px;
        justify-content: center;
        text-align: center;
      }

      .created-by {
        flex: 0 0 10%;
        min-width: 150px;
        justify-content: center;
        text-align: center;
      }

      .actions {
        flex: 0 0 210px;
      }
      /* .actions {
        min-width: 190px;

        & > .section {
          justify-content: flex-start;
        }
      } */
    }
  }

  .page-button {
    margin-top: 25px;
    justify-content: flex-end;
  }

  .rfq_status {
    position: relative;

    .image-control {
      position: absolute;
      right: 20px;
      cursor: pointer;
    }
  }

  /* Tooltip
  ------------------------------- */
  .__react_component_tooltip {
    padding: 5px 10px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.show {
      opacity: 1;
    }

    &.background-white {
      background-color: white;
      box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
      border: 0 !important;
      color: ${VARIABLES.COLORS.GRAY_3};
      white-space: pre-line;

      &.place-bottom {
        border-bottom-color: white;

        &:after,
        &before {
          display: none;
        }
      }

      &.place-top {
        border-top-color: white;

        &:after,
        &before {
          display: none;
        }
      }
    }
  }
  /* Truncate String
  ------------------------------- */
  .truncate_string_span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    display: inline-block;
    cursor: pointer;
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .__react_component_tooltip {
      padding: 5px 9px;
      font-size: 16px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .__react_component_tooltip {
      padding: 4px 8px;
      font-size: 15px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 450px;
          min-width: 230px;
        }
      }

      &.status {
        .status-icon-help {
          width: 17px;
          left: 115px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 4px 7px;
      font-size: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 400px;
          min-width: 210px;
        }
      }

      &.status {
        .status-icon-help {
          left: 105px;
          width: 16px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 3px 6px;
      font-size: 13px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 350px;
          min-width: 180px;
        }
      }

      &.status {
        .status-icon-help {
          left: 95px;
          width: 15px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 3px 5px;
      font-size: 12px;
    }
  }
`
